module.exports = __webpack_public_path__ + "static/media/check.fa1da607.gif";